module.exports = __webpack_public_path__ + "img/cod-black-ops-iiii.a06b0847.png";